export const DEFAULT_ERROR = 'Errore durante il recupero dei dati. Provare a ricaricare la pagina. Se l\'errore persiste contattare l\'amministratore';

export const TIPO_CORSO = Object.freeze({
    FORMAZIONE: 'A',
    SERVIZIO_CIVILE: 'B',
    GARANZIA_GIOVANI: 'C',
    COFO: 'D'
});

export const TIPO_INDIVIDUO = Object.freeze({
    ALLIEVI: 'allievi',
    DOCENTI: 'docenti',
    TUTOR: 'tutor'
})

/******************** Enum per i Tab docenti/allievi ****************/
export const TABS_CHOOSEN = Object.freeze({
    ALLIEVI: 'allievi',
    DOCENTI: 'docenti',
    TUTOR: 'tutor'
});

export const TAB_ENUM_INDIVIDUI_TARGET = Object.freeze({
    allievi: {
        name: 'allievi',
        propCorso: 'allievi',
        props: 'individui',
        timbratura: 'allievo',
        validazione: 'idAnagrafica',
        castelletto: 'giustificativiPerTipo',
        orePresenza: 'orePresenza',
        oreEffettive: 'ore',
        castellettoLabel: 'tipoGiustificativo'
    },
    docenti: {
        propCorso: 'docenti',
        props: 'docenti',
        timbratura: 'docente',
        validazione: 'idAnagrafica',
        castelletto: 'unitaFormativePerTipo',
        orePresenza: 'orePresenza',
        oreEffettive: 'ore',
        castellettoLabel: 'unitaFormativa'
    },
    tutor: {
        propCorso: 'docenti',
        props: 'docenti',
        timbratura: 'docente',
        validazione: 'idDocente',
        castelletto: 'unitaFormativePerTipo',
        orePresenza: 'orePianificazione',
        castellettoLabel: 'unitaFormativa'
    }
});
/******************** Enum per i Tab docenti/allievi ****************/

/******************** Enum per Tipo recupero profili ****************/

export const TIPO_RECUPERO_PROFILO_ORARIO = Object.freeze({
    SINGOLO_INDIVIDUO: 'Singolo Individuo',
    RIEPILOGO_INDIVIDUI: 'Riepilogo individui'
});

/******************** Enum per Tipo recupero profili ****************/


/**************** Registro **********************************/

export const TIPO_REGISTRO = Object.freeze({
    SCR_MESE: 'Servizio Civile :: Singolo individuo',
    RESOCONTO_MESE_SINGOLO_INDIVIDUO: 'Resoconto mese Corso/SCR :: Singolo Individuo',
    MESE: 'Tutti gli individui per il mese corrente'
});
/**************** Registro **********************************/

/**************** CustomToolBar Calendario ******************/

export const CONVERT_TYPE = Object.freeze({
    month: 'Mese',
    week: 'Settimana',
    agenda: 'Agenda'
});

/**************** CustomToolBar Calendario ******************/

export const ACTION = ['C'];

export const ENUM_TIPO = Object.freeze({
    EA: {tipoAzione: 'A', descrizione: 'Entrata'},
    UA: {tipoAzione: 'A', descrizione: 'Uscita'},
    EM: {tipoAzione: 'M', descrizione: 'Entrata'},
    UM: {tipoAzione: 'M', descrizione: 'Uscita'},
    EG: {tipoAzione: 'G', descrizione: 'Entrata'},
    UG: {tipoAzione: 'G', descrizione: 'Uscita'},
});

/****************** ProfiliOrariFSE *******************/

export const FIRST_ROW = ['giorni', 'dataInizio', 'dataFine', 'deltaPre', 'deltaPost'];
export const SECOND_ROW = ['descrizione'];

/****************** ProfiliOrariFSE *******************/

/****************** ProfiloSCRForm ********************/

export const GIORNALIERO_DATA = ['giorni', 'tempo', 'delta', 'oraEntrata', 'oraUscita'];

/****************** ProfiloSCRForm ********************/


export const ENUM_RISULTATO = Object.freeze({
    ATTENZIONE: 'btn btn-sm btn-warning',
    ERRORE: 'btn btn-sm btn-danger',
    INFO: 'btn btn-sm btn-primary',
    SUCCESS: 'btn btn-sm btn-success',
    ASSENZA_AUTOMATICA_GIUSTIFICATA: 'btn btn-sm btn-info'
});

/******************* RegistroDettaglioTable *************/

export const DISABLED_CODES = ['S001', 'S002']

export const COLOR_ERROR = Object.freeze({
    ATTENZIONE: 'table-warning',
    ERRORE: 'table-danger',
    INFO: 'table-primary',
    ASSENZA_AUTOMATICA_GIUSTIFICATA: 'table-info'
});

export const ENUM_TIMBRATURE = Object.freeze({

    EA: {tipo: 'A', azione: 'Entrata', descrizione: 'Entrata Automatica'},
    UA: {tipo: 'A', azione: 'Uscita', descrizione: 'Uscita Automatica'},
    EM: {tipo: 'M', azione: 'Entrata', descrizione: 'Entrata Manuale'},
    UM: {tipo: 'M', azione: 'Uscita', descrizione: 'Uscita Manuale'},
    E: {tipo: null, azione: 'Entrata', descrizione: 'Entrata'},
    U: {tipo: null, azione: 'Uscita', descrizione: 'Uscita'}
});

/******************* RegistroDettaglioTable *************/

/****************** Giustificativi *********************/

export const ENUM_OPTION_FIELD = Object.freeze({
    Giornaliero: ['dataInizio', 'dataFine', 'idTipoGiustificativo', 'note'],
    Orario: ['oraInizio', 'oraFine', 'idTipoGiustificativo', 'note']
});

/****************** Giustificativi *********************/

export const TYPE_INSERT = Object.freeze({
    SINGLE_MANUAL: 'single insert', // enum utilizzata nella visualizzazione RegistroDettaglio per singola timbratura
    MULTI_MANUAL: 'multiple inserts justification or time stamps', // enum utilizzato nel tab Registro, dove l'ente deve scegliere il giorno sul quale fare la timbratura
    MULTI_MANUALI_IN_PRESENZE: 'multiple inserts time stamps from tab presenze', // enum utilizzato per timbratura, ruolo docente e superiori, nel tab Presenze
    AUTOMATICHE: 'automatiche' // enum utilizzato nel tab Presenze per le timbrature automatiche
})

export const REGEX_CODICE_FISCALE = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
export const REGEX_DATE_FORMAT = /^([0-9]{4})-([0-9]{2})-([0-9]{2})/;

export const MAP_FIELDS_INSERIMENTO_ANAGRAFICA = Object.freeze({
    admin: {values: ['codiceFiscale']},
    ente: {values: ['codiceFiscale', 'codiceFiscaleEnte']},
    utr: {values: ['codiceFiscale', 'codice']},
    rda: {values: ['codiceFiscale', 'codice']}
});

export const ENUM_RUOLI = Object.freeze({
    ADMIN: 'admin',
    ENTE: 'ente',
    UTR: 'utr',
    RDA: 'rda'
})

export const ENUM_BUTTON_FORM = Object.freeze({
    S: {classes: 'btn btn-danger shadow', label: 'Svalida', icon: 'fa fa-times fa-fw mr-2', message: 'Svalidazione'},
    E: {classes: 'btn btn-primary shadow', label: 'Ingresso', icon: 'fa fa-sign-in fa-fw mr-1', message: 'Timbratura Ingresso (Manuale)'},
    U: {classes: 'btn btn-success shadow', label: 'Uscita', icon: 'fa fa-sign-out fa-fw mr-1', message: 'Timbratura Uscita (Manuale)'},
    G: {classes: 'btn btn-orange shadow', label: 'Giustificativo', icon: 'fa fa-address-card fa-fw mr-2', message: 'Giustificativo'}
});

/****************** Monitoraggio *******************/

export const VALIDATION_TYPE = Object.freeze({
    CORSO: 'corso',
    ALLIEVO: 'allievo',
    DOCENTE: 'docente'
});

/****************** Monitoraggio *******************/

/****************** Rotte disabilitate se corso finito *******************/

export const DISABLED_ROUTE_IF_COURSE_FINISHED = Object.freeze(
    ['Presenze', 'Pianificazione', 'Profilazione']
);

/****************** Rotte disabilitate se corso finito *******************/

export const REGISTRO = Symbol('registro');
export const CALENDARIO = Symbol('calendario');

/****************** Ruoli che possono modificare tutti i giorni *******************/
export const EDIT_ALL_DAY_ROLES = Object.freeze(
    ["SYSTEMADMIN", "ADMIN", "RDA"]
);
/****************** Ruoli che possono modificare tutti i giorni *******************/


